// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section {
  position: relative;
  scroll-margin-top: 4.5rem;
  background: var(--brand-primary);
  color: var(--text-on-dark);
  overflow: hidden;
}

.contact-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse at bottom,
    var(--color-navy-400) 0%,
    transparent 60%
  );
  opacity: 0.6;
  pointer-events: none;
}

.contact-section__inner {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  padding: 4rem 1.25rem;
  display: grid;
  gap: 2.5rem;
}

.contact-section__intro {
  text-align: center;
  max-width: 56ch;
  margin: 0 auto;
}

.contact-section__eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--interactive);
  margin-bottom: 0.75rem;
}

.contact-section__title {
  font-size: clamp(1.5rem, 3vw, 2.1rem);
  font-weight: 700;
  color: var(--color-cream-200);
  margin-bottom: 0.6rem;
}

.contact-section__subtitle {
  color: var(--text-on-dark);
  opacity: 0.8;
  font-size: 1rem;
  line-height: 1.6;
}

.contact-section__content {
  display: grid;
  gap: 1.25rem;
}

/* ---------- Email banner ---------- */

.contact-email {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 30rem;
  margin: 0 auto;
  width: 100%;
  padding: 1.1rem 1.5rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  color: var(--text-on-dark);
  transition:
    border-color var(--transition),
    background var(--transition),
    transform var(--transition);
}

.contact-email:hover {
  border-color: var(--interactive);
  background: rgba(255, 255, 255, 0.07);
  transform: translateY(-2px);
}

.contact-email:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}

.contact-email__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  flex-shrink: 0;
  border-radius: var(--radius-pill);
  background: var(--interactive);
  color: var(--interactive-fg);
}

.contact-email__icon svg {
  width: 1.4rem;
  height: 1.4rem;
}

.contact-email__text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.contact-email__label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--interactive);
}

.contact-email__value {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-cream-200);
  overflow-wrap: anywhere;
}

/* ---------- People grid ---------- */

.contact-people {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.25rem;
}

.contact-person {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: var(--bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  transition: transform var(--transition), box-shadow var(--transition);
}

.contact-person:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.contact-person__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  border-radius: var(--radius-pill);
  background: var(--brand-primary);
  color: var(--interactive);
  border: 2px solid var(--interactive);
  font-size: 1.15rem;
  font-weight: 700;
}

.contact-person__info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  flex: 1 1;
}

.contact-person__name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.contact-person__phone {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.contact-person__actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.contact-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--radius-pill);
  color: var(--color-white);
  transition:
    transform var(--transition),
    filter var(--transition);
}

.contact-action svg {
  width: 1.15rem;
  height: 1.15rem;
}

.contact-action:hover {
  transform: scale(1.08);
  filter: brightness(1.08);
}

.contact-action:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.contact-action--call {
  background: var(--brand-primary);
}

.contact-action--whatsapp {
  background: var(--color-success);
}

/* ---------- Responsive ---------- */

@media (max-width: 640px) {
  .contact-section__inner {
    padding: 3rem 1rem;
    gap: 2rem;
  }

  .contact-email {
    flex-direction: column;
    text-align: center;
  }

  .contact-person {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }

  .contact-person__info {
    align-items: center;
    flex-basis: 100%;
  }

  .contact-person__actions {
    flex-basis: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/ContactSection/ContactSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B;;;+BAG6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,sCAAsC;;AAEtC;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,yBAAyB;EACzB;;4BAE0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qCAAqC;;AAErC;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;AACF","sourcesContent":[".contact-section {\n  position: relative;\n  scroll-margin-top: 4.5rem;\n  background: var(--brand-primary);\n  color: var(--text-on-dark);\n  overflow: hidden;\n}\n\n.contact-section::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    ellipse at bottom,\n    var(--color-navy-400) 0%,\n    transparent 60%\n  );\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.contact-section__inner {\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 4rem 1.25rem;\n  display: grid;\n  gap: 2.5rem;\n}\n\n.contact-section__intro {\n  text-align: center;\n  max-width: 56ch;\n  margin: 0 auto;\n}\n\n.contact-section__eyebrow {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: var(--interactive);\n  margin-bottom: 0.75rem;\n}\n\n.contact-section__title {\n  font-size: clamp(1.5rem, 3vw, 2.1rem);\n  font-weight: 700;\n  color: var(--color-cream-200);\n  margin-bottom: 0.6rem;\n}\n\n.contact-section__subtitle {\n  color: var(--text-on-dark);\n  opacity: 0.8;\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.contact-section__content {\n  display: grid;\n  gap: 1.25rem;\n}\n\n/* ---------- Email banner ---------- */\n\n.contact-email {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  max-width: 30rem;\n  margin: 0 auto;\n  width: 100%;\n  padding: 1.1rem 1.5rem;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-lg);\n  color: var(--text-on-dark);\n  transition:\n    border-color var(--transition),\n    background var(--transition),\n    transform var(--transition);\n}\n\n.contact-email:hover {\n  border-color: var(--interactive);\n  background: rgba(255, 255, 255, 0.07);\n  transform: translateY(-2px);\n}\n\n.contact-email:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n\n.contact-email__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  flex-shrink: 0;\n  border-radius: var(--radius-pill);\n  background: var(--interactive);\n  color: var(--interactive-fg);\n}\n\n.contact-email__icon svg {\n  width: 1.4rem;\n  height: 1.4rem;\n}\n\n.contact-email__text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.contact-email__label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--interactive);\n}\n\n.contact-email__value {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-cream-200);\n  overflow-wrap: anywhere;\n}\n\n/* ---------- People grid ---------- */\n\n.contact-people {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.25rem;\n}\n\n.contact-person {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: var(--bg-surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  transition: transform var(--transition), box-shadow var(--transition);\n}\n\n.contact-person:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.contact-person__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 3rem;\n  height: 3rem;\n  border-radius: var(--radius-pill);\n  background: var(--brand-primary);\n  color: var(--interactive);\n  border: 2px solid var(--interactive);\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.contact-person__info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.contact-person__name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.contact-person__phone {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.contact-person__actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.contact-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: var(--radius-pill);\n  color: var(--color-white);\n  transition:\n    transform var(--transition),\n    filter var(--transition);\n}\n\n.contact-action svg {\n  width: 1.15rem;\n  height: 1.15rem;\n}\n\n.contact-action:hover {\n  transform: scale(1.08);\n  filter: brightness(1.08);\n}\n\n.contact-action:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.contact-action--call {\n  background: var(--brand-primary);\n}\n\n.contact-action--whatsapp {\n  background: var(--color-success);\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 640px) {\n  .contact-section__inner {\n    padding: 3rem 1rem;\n    gap: 2rem;\n  }\n\n  .contact-email {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .contact-person {\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .contact-person__info {\n    align-items: center;\n    flex-basis: 100%;\n  }\n\n  .contact-person__actions {\n    flex-basis: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
